
export default {
  name: "AttSchedule",
  props: {
    review: {
      type: Boolean,
      required: false,
      default: false,
    },
    monthDate: {
      type: Date,
      required: false,
      default: null,
    },
    employee: {
      type: Object,
      required: false,
      default: null,
    },
  },
  created() {
    let t = this;

    let d = new Date();

    if (t.monthDate) {
      t.year = Number(t.monthDate.getFullYear());
      t.month = Number(t.monthDate.getMonth() + 1);
    }

    if (t.year == 0)
      t.year = d.getFullYear();

    if (d.getMonth() == 11) {
      t.year++;
      t.month = 1;
    }
    else if (t.month == 0)
      t.month = d.getMonth() + 2;

    t.holiday = t.dict.holiday[t.month];

    t.refreshMonth(new Date(t.year, t.month - 1, 1));

  },
  activated() { },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {

      let t = this;

      let p = {};

      if (t.review) {
        p.employee_id = t.employee.id;
      }
      else {
        p.employee_id = t.U.id;
      }

      axios.get('employeeConfig', { params: p }).then(res => {

        if (res.data.status == 1) {

          if (res.data.options.items.length == 0) {
            A.err('あなたの出退勤時間が設定されていません。管理者に連絡して処理してください。');
          }
          else {

            t.config = res.data.options.items[0];

            t.config.static_rest_day = t.config.static_rest_day.split(',');

            t.list.rest_day.forEach(item => {

              item.static_rest = false;

              if (t.config.static_rest_day.indexOf(item.id.toString()) > -1)
                item.static_rest = true;

            });

            let arr = JSON.parse(t.config.att_config);

            t.config.att_config = arr;

            arr.forEach(item => {
              item.text = item.start + '-' + (item.tomorrow == 1 ? '翌日' : '') + item.end;
            });

            t.list.attTimeRange = arr;

            t.list.attTimeRange_am = [];
            t.list.attTimeRange_pm = [];

            t.list.attTimeRange.forEach(item => {

              let date1 = new Date('2025-01-01 ' + item.start);
              let date2 = new Date('2025-01-01 ' + item.end);
              let tomorrow2 = 0;
              if (item.tomorrow == 1) {
                date2 = new Date('2025-01-02 ' + item.end);
              }
              let timeDifferenceInMillis = Math.abs(date2 - date1);
              let minutesDiff = timeDifferenceInMillis / (1000 * 60);

              minutesDiff = (minutesDiff - 60) / 2;

              date2.setMinutes(-minutesDiff);

              let text = date2.format('hh:mm') + '-' + item.end;

              if (item.tomorrow == 1) {
                if (date2.getDate() == 2) {
                  text = '翌日' + date2.format('hh:mm') + '-' + item.end;
                  tomorrow2 = 1;
                }
              }

              t.list.attTimeRange_pm.push({
                'start': date2.format('hh:mm'),
                'end': item.end,
                'text': text,
                'tomorrow': item.tomorrow,
                'tomorrow2': tomorrow2
              });

              date1 = new Date('2025-01-01 ' + item.start);
              date2 = new Date('2025-01-01 ' + item.end);
              if (item.tomorrow == 1) {
                date2 = new Date('2025-01-02 ' + item.end);
              }

              date1.setMinutes(date1.getMinutes() + minutesDiff);

              text = item.start + '-' + date1.format('hh:mm');

              if (item.tomorrow == 1) {
                if (date1.getDate() == 2 && date2.getDate() == 2) {
                  text = item.start + '-翌日' + date1.format('hh:mm');
                  tomorrow2 = 1;
                }
              }

              t.list.attTimeRange_am.push({
                'start': item.start,
                'end': date1.format('hh:mm'),
                'text': text,
                'tomorrow': item.tomorrow,
                'tomorrow2': tomorrow2
              });

            });

            t.loadMonthly();
          }
        }
      });

    },

    refreshMonth(r) {

      let t = this;

      let today = Date.today();

      t.allowModify = false;

      if (today.getMonth() + 1 == r.getMonth() || (today.getMonth() == 11 && r.getMonth() == 0 && today.getFullYear() == (r.getFullYear() - 1))) {
        //允许编辑下个月
        if (today.getDate() >= 15 && today.getDate() <= 25)
          t.allowModify = true;
      }
    },

    minusMonth() {
      let t = this;
      let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), -1);
      t.month = r.getMonth() + 1;
      t.holiday = t.dict.holiday[t.month];
      t.year = r.getFullYear();

      t.refreshMonth(r);
      t.loadMonthly();
    },

    plusMonth() {
      let t = this;
      let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), 1);
      t.month = r.getMonth() + 1;
      t.holiday = t.dict.holiday[t.month];
      t.year = r.getFullYear();

      t.refreshMonth(r);
      t.loadMonthly();
    },

    loadMonthly() {
      let t = this;

      t.dict.holiday = {
        5: {
          days: 3,
          name: 'GW',
          left: 3
        },
        8: {
          days: 3,
          name: '盆休',
          left: 3
        }
      };

      let year = (new Date()).getFullYear();
      let year2 = t.year;
      let month = (new Date()).getMonth() + 1;

      let month2 = t.month;

      t.isPast = year2 < year || (year == year2 && month2 < month);

      let dayIndexs = ["日", "月", "火", "水", "木", "金", "土"];

      t.list.dateGrid.clear();

      let params = {
        'month': t.month,
        'year': t.year,
        '_scene': 'attSchedule'
      };

      if (t.employee) {
        params.employee_id = t.employee.id;
      }
      else {
        params.employee_id = t.U.id;
      }

      t.list.dateGrid = [];
      t.list.placeholder = [];

      t.stats.dynamic_rest_day_left = Number(t.config.monthly_dynamic_rest_day || 0);

      axios
        .get("attScheduleReview", { params: params })
        .then((res) => {
          if (res.data.status == 1) {

            let lastSubmitDict = {};

            t.lastSubmit = res.data.options.items[0];

            let dictShift = listToDict(res.data.options.shifts ?? {}, "date");

            t.editable = true;

            if (t.lastSubmit) {
              lastSubmitDict = listToDict(JSON.parse(t.lastSubmit.data), 'date');
              t.editable = false;
            }

            let dictDate = {};

            let day = getDaysInMonth(t.year, t.month);

            let d = (new Date(t.year, t.month - 1, day)).getDay();

            if (d > 0) {
              d = 7 - d;
            }

            let entryDate;
            if (t.employee) {
              entryDate = new Date(t.employee.entry_date || '2019-01-01');
            }
            else {
              entryDate = new Date(t.U.entry_date || '2019-01-01');
            }

            for (let i = 0; i < day; i++) {
              let curDate = new Date(t.year, t.month - 1, i + 1);
              let date = curDate.format("MM/dd");
              let fullDateText = curDate.format("yyyy-MM-dd");
              let item = {
                full_date: fullDateText,
                date: date,
                day_index_text: dayIndexs[curDate.getDay()],
                day_index: curDate.getDay(),
                static_rest: t.config.static_rest_day.indexOf(curDate.getDay().toString()) > -1 ? 1 : 0,
                showAttTimeRange: false,
                //调休
                dynamic_rest: 0,
                next_month: 0,
                before_entry: curDate < entryDate,

                leave: null,
                leaveReq: null,
                shift: null,
              };
              item.f = {
                work: 1,
                att_time_range: null,
                rest_to_work: 0,
                rest_date: '',
                start_time: '',
                end_time: '',
                rest_am: 0,
                rest_pm: 0,
                tomorrow: 0,
                tomorrow2: 0,
                att_text: ''
              };

              if (t.config.att_config && t.config.att_config.length > 0 && item.static_rest == 0) {
                item.f.att_time_range = t.config.att_config[0];
                item.f.start_time = item.f.att_time_range.start;
                item.f.end_time = item.f.att_time_range.end;
                item.f.tomorrow = item.f.att_time_range.tomorrow;
                item.f.tomorrow2 = item.f.att_time_range.tomorrow2;
                item.f.att_text = item.f.start_time + '-' + (item.f.tomorrow ? '翌日' : '') + item.f.end_time;
              }

              if (lastSubmitDict[item.full_date]) {
                mirror(lastSubmitDict[item.full_date], item.f);
              }

              if (t.holiday && item.f.work == 3) {
                t.holiday.left--;
              }

              // item.leaveReq = dictLeave[fullDateText];
              item.shift = dictShift[fullDateText];

              t.list.dateGrid.push(item);
              dictDate[item.full_date] = item;
            }

            for (let i = 0; i < d; i++) {
              let curDate = new Date(t.year, t.month, i + 1);
              let date = curDate.format("MM/dd");
              let fullDateText = curDate.format("yyyy-MM-dd");
              let item = {
                full_date: curDate.format("yyyy-MM-dd"),
                date: date,
                day_index_text: dayIndexs[curDate.getDay()],
                day_index: curDate.getDay(),
                static_rest: t.config.static_rest_day.indexOf(curDate.getDay().toString()) > -1 ? 1 : 0,
                showAttTimeRange: false,
                //调休
                dynamic_rest: 0,
                next_month: 1,
                before_entry: curDate < entryDate,

                leave: null,
                // leaveReq: null,
                shift: null,
              };
              item.f = {
                work: 1,
                att_time_range: null,
                rest_to_work: 0,
                rest_date: '',
                start_time: '',
                end_time: '',
                rest_am: 0,
                rest_pm: 0,
                tomorrow: 0,
                tomorrow2: 0,
                att_text: ''
              };

              if (lastSubmitDict[item.full_date]) {
                mirror(lastSubmitDict[item.full_date], item.f);
              }

              // item.leaveReq = dictLeave[fullDateText];
              item.shift = dictShift[fullDateText];
              t.list.dateGrid.push(item);
              dictDate[item.full_date] = item;
            }

            for (const date in lastSubmitDict) {

              let dateItem = lastSubmitDict[date];

              if (dateItem.work == 1 || dateItem.work == 2) {
                dictDate[dateItem.date].static_rest = 0;
              }

              if (dateItem.rest_to_work == 1 && dictDate[dateItem.rest_date]) {
                t.stats.dynamic_rest_day_left--;
                dictDate[dateItem.rest_date].dynamic_rest = 1;
                dictDate[dateItem.rest_date].work_date = date;
                dictDate[dateItem.date].restDateItem = dictDate[dateItem.rest_date];
              }

            }

            t.list.dateGrid.forEach(item => {

              if (item.shift) {
                let date = item.shift.rest_date;
                if (dictDate[date]) {
                  dictDate[date].dynamic_rest = 1;
                  dictDate[date].work_date = item.full_date;
                }
              }

            });

            if (res.data.options.leaves) {
              res.data.options.leaves.forEach(leaveReq => {
                let leave_data = JSON.parse(leaveReq.leave_data);
                leave_data.forEach(leaveDateItem => {
                  let date = leaveDateItem.date;
                  if (dictDate[date]) {
                    dictDate[date].leave = leaveDateItem;
                    dictDate[date].leave.type = leaveReq.type;
                    dictDate[date].leave.id = leaveReq.id;
                  }
                });
              });
            }



            let days = new Date(t.list.dateGrid[0].full_date).getDay();

            t.list.placeholder = [];

            if (days == 0) {
              days = 6;
            } else {
              days--;
            }

            for (let j = 0; j < days; j++) {
              t.list.placeholder.push("");
            }

          }
        });
    },

    resetAttScheduleReview() {

      let t = this;

      let form = {
        employee_id: t.employee.id,
        year: t.year,
        month: t.month
      };

      axios.post('attScheduleReview/reset', form).then(res => {
        if (res.data.status == 1) {
          A.toast('リセット');
          t.loadMonthly();
        }
      });

    },

    onSelectAttTimeRange(option, item) {
      item.f.start_time = option.start;
      item.f.end_time = option.end;
      item.f.tomorrow = option.tomorrow;
      item.f.tomorrow2 = option.tomorrow2;
      item.f.att_text = option.text;
    },
    setAsWorkDay(item) {

      let t = this;

      if (item != this.workDateItem && this.picking) {
        A.err((new Date(this.workDateItem.date)).format('M/d') + "の振替休日の選択中です。<br>選択を完了するか、リセットをクリックしてから操作を続けてください。");
        return;
      }
      if (t.stats.dynamic_rest_day_left == 0) {
        A.err('今月の振替休日の回数はすでに使い果たしました。');
        return;
      }
      t.stats.dynamic_rest_day_left--;
      item.f.rest_to_work = 1;
      this.workDateItem = item;
      this.picking = true;
    },
    resetWorkDay(item) {

      let t = this;

      if (item != this.workDateItem && this.picking) {
        A.err((new Date(this.workDateItem.date)).format('M/d') + "の振替休日の選択中です。<br>選択を完了するか、リセットをクリックしてから操作を続けてください。");
        return;
      }

      if (item.f.rest_to_work == 1) {
        t.stats.dynamic_rest_day_left++;
        item.f.rest_to_work = 0;
        item.f.start_time = '';
        item.f.att_text = '';
        item.f.end_time = '';
        item.f.rest_date = '';
        item.f.tomorrow = 0;
        item.f.tomorrow2 = 0;
        if (item.restDateItem) {
          item.restDateItem.dynamic_rest = 0;
          item.work_date = null;
        }
        this.picking = false;
        this.workDateItem = null;
      }
    },
    selectRestDate(item) {

      let t = this;

      item.dynamic_rest = 1;
      item.work_date = t.workDateItem.full_date;
      item.f.rest_am = 0;
      item.f.rest_pm = 0;

      t.workDateItem.f.rest_date = item.full_date;
      t.workDateItem.restDateItem = item;

      t.picking = false;

    },

    buildData() {
      let t = this;

      let arr = [];

      for (let i = 0; i < t.list.dateGrid.length; i++) {
        let item = t.list.dateGrid[i];
        let f = item.f;

        if (item.dynamic_rest == 1) {
          continue;
        }

        if (item.static_rest == 0 || item.f.rest_to_work) {

          if (item.f.rest_to_work && !item.f.rest_date) {
            A.err(item.date + 'の振替休日がまだ選択されていません。');
            return;
          }

          if (!item.before_entry) {
            if (!f.start_time && (!f.rest_am && !f.rest_pm) && (f.work == 1 || f.work == 2)) {
              if (item.next_month == 0 || (item.next_month == 1 && item.static_rest == 1 && f.rest_to_work)) {
                A.err(item.date + 'の出勤時間が指定されていません。');
                return;
              }
            }
            if (item.next_month == 0 || f.rest_to_work) {
              arr.push(
                {
                  'date': item.full_date,
                  'start_time': f.work > 0 && f.work != 3 ? f.start_time : '',
                  'end_time': f.work > 0 && f.work != 3 ? f.end_time : '',
                  'work': f.work,
                  'rest_to_work': f.rest_to_work,
                  'rest_date': f.rest_date,
                  'rest_am': f.rest_am ? 1 : 0,
                  'rest_pm': f.rest_pm ? 1 : 0,
                  'tomorrow': f.tomorrow,
                  'tomorrow2': f.tomorrow2,
                  'att_text': f.work > 0 && f.work != 3 ? f.att_text : ''
                }
              );
            }
          }

        }
      }

      if (arr.length == 0) {
        A.err('変更は検出されませんでした。');
      }

      return arr;
    },

    submit() {

      let t = this;

      let arr = t.buildData();

      if (arr && arr.length > 0) {

        let p = { 'data': JSON.stringify(arr), 'month': t.month, 'year': t.year };

        if (t.busying)
          return;

        t.busying = true;

        axios.post('attScheduleReview/submit', p).then(res => {

          t.busying = false;

          if (res.data.status == 1) {
            t.lastSubmit = res.data.options.item;
            A.show('あなたの勤務表はすでに提出されました。管理者の審査をしばらくお待ちください。', '提出済み', 'info');
            t.editable = false;
          }
          else if (res.data.status == 2) {
            A.show('最終提出期限を過ぎています。管理者に連絡して対応してください。', t.month + '月分', 'error');
          }
        });

      }

    },

    cancel() {

      let t = this;

      axios.post('attScheduleReview/cancel/' + t.lastSubmit.id).then(res => {
        if (res.data.status == 1) {
          A.show('あなたは勤務表を撤回しました。修正が完了したら、忘れずに再度提出してください。', 'キャンセル済み', 'warning');
          t.lastSubmit = null;
        }
      });

    },

    getAttTimeRange(start_time, end_time, suffix) {

      let t = this;

      let index = 0;

      suffix = suffix || '';

      t.list.attTimeRange.forEach((item, i) => {
        if (item.start == start_time && item.end == end_time) {
          index = i;
        }
      });

      t.list.attTimeRange_am.forEach((item, i) => {
        if (item.start == start_time && item.end == end_time) {
          index = i;
        }
      });

      t.list.attTimeRange_pm.forEach((item, i) => {
        if (item.start == start_time && item.end == end_time) {
          index = i;
        }
      });

      return t.list['attTimeRange' + suffix][index];

    },


    restChange(item) {

      let t = this;
      let attTimeRange = null;

      if (item.f.rest_am && item.f.rest_pm) {
        item.f.work = 0;
      }
      else if (!item.f.rest_am && !item.f.rest_pm) {
        attTimeRange = t.getAttTimeRange(item.f.start_time, item.f.end_time);
        item.f.start_time = attTimeRange.start;
        item.f.end_time = attTimeRange.end;
        item.f.att_text = attTimeRange.text;
        item.f.tomorrow = attTimeRange.tomorrow;
        item.f.tomorrow2 = attTimeRange.tomorrow2;
      }
      else {
        item.f.work = 1;
        if (item.f.rest_am) {
          attTimeRange = t.getAttTimeRange(item.f.start_time, item.f.end_time, '_pm');
        }
        else if (item.f.rest_pm) {
          attTimeRange = t.getAttTimeRange(item.f.start_time, item.f.end_time, '_am');
        }

        item.f.start_time = attTimeRange.start;
        item.f.end_time = attTimeRange.end;
        item.f.att_text = attTimeRange.text;
        item.f.tomorrow = attTimeRange.tomorrow;
        item.f.tomorrow2 = attTimeRange.tomorrow2;

      }
    },

    restHolidayChange(item) {

      let t = this;

      let count = 0;

      if (t.holiday) {
        t.list.dateGrid.forEach(item => {
          if (item.f.work == 3) {
            count++;
          }
        });
        t.holiday.left = t.holiday.days - count;
      }
    },

    tapHint() {
      // if (this.review) {
      //   A.show('勤務表を修正する必要がある場合は、ページ「取り消す」をクリックして修正を行い、その後再度提出してください。', '勤務表はすでに提出されました', 'error');
      // }
      // else {
      //   A.show('勤務表を修正する必要がある場合は、ページ「取り消す」をクリックして修正を行い、その後再度提出してください。', '勤務表はすでに提出されました', 'error');
      // }
    },

    notifyEmployee() {

      let t = this;

      A.show('その社員に通知を送信しました。', '', 'info');

      axios.post('attScheduleReview/notifyEmployee', { 'review_id': t.lastSubmit.id }).then(res => {
        if (res.data.status == 1) {

        }
      });

    },

    confrim() {

      let t = this;

      let arr = t.buildData();

      if (arr && arr.length > 0) {

        let f = {
          'data': JSON.stringify(arr),
          'month': t.month
        };

        if (t.busying)
          return;

        t.busying = true;

        t.submitCanceledLeaves();

        axios.post('attScheduleReview/confirm/' + t.lastSubmit.id, f).then(res => {

          t.busying = false;

          if (res.data.status == 1) {
            t.lastSubmit.status = 1;
            t.lastSubmit.reject_reason = '';
            t.$emit('change', f.data);
            A.show('保存済み', '', 'success');
          }
        });

      }
    },

    proxySubmit() {

      let t = this;

      let arr = t.buildData();

      if (arr && arr.length > 0) {
        let f = {
          'data': JSON.stringify(arr),
          'month': t.month,
          'year': t.year,
          'employee_id': t.employee.id
        };

        if (t.busying)
          return;

        t.busying = true;

        t.submitCanceledLeaves();

        axios.post('attScheduleReview/proxySubmit', f).then(res => {
          t.busying = false;

          if (res.data.status == 1) {
            t.lastSubmit = res.data.options.item;
            t.$emit('change', res.data.options.item.data);
            A.show('保存済み', '', 'success');
          }
        });
      }

    },

    tapDateItem(item) {
      // if (item.leave)
      //   A.err('すでに確定された休暇申請は、ここで変更することはできません。');
    },

    cancelLeave(item) {

      let t = this;

      if (item.leave) {
        t.canceledLeaves.push({
          'id': item.leave.id,
          'date': item.full_date
        });
        delete item.leave;
        t.$forceUpdate();
      }
    },

    submitCanceledLeaves() {
      let t = this;
      if (t.canceledLeaves.length > 0)
        axios.post('clockIn/cancelLeaves', { leave_data: t.canceledLeaves }).then(res => {
          if (res.data.status == 1) {
            t.canceledLeaves = [];
          }
        });
    },

    cancelRest(item) {
      item.static_rest = 0;
    }
  },
  data() {
    return {
      isPast: false,
      year: 0,
      month: 0,
      allowModify: true,
      ready: false,
      busying: false,
      config: null,
      picking: false,
      workDateItem: null,
      lastSubmit: null,
      showRejectEditor: false,
      editable: false,
      holiday: null,

      canceledLeaves: [],

      dict: {
        holiday: {
          5: {
            days: 3,
            name: 'GW',
            left: 3
          },
          8: {
            days: 3,
            name: '盆休',
            left: 3
          }
        },
      },
      list: {
        dateGrid: [],
        placeholder: [],
        attTimeRange: [],
        attTimeRange_am: [],
        attTimeRange_pm: [],
        rest_day: [
          { id: 1, text: "月" },
          { id: 2, text: "火" },
          { id: 3, text: "水" },
          { id: 4, text: "木" },
          { id: 5, text: "金" },
          { id: 6, text: "土" },
          { id: 0, text: "日" },
        ],
      },
      item: null,
      search: {
        employee: null,
      },
      stats: {
        rest_day_left: 0,
        dynamic_rest_day_left: 0,
      },
    };
  },
};
